import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/440'

const RevenueAtSelectLocationsTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="revenue.tabs.revenue_at_select_locations"
  />
)

export default RevenueAtSelectLocationsTab
